export const VIEWPOINT_REPORT_TYPES: Array<{ code: string; label: string }> = [
  { code: "stock_recommend", label: "推荐股票" },
  { code: "promised_return", label: "承诺收益" },
  { code: "political", label: "涉及政治" },
  { code: "porn_violence", label: "色情暴力" },
];

export const REPORT_TARGET_TYPE_VIEWPOINT = "viewpoint";

export type ViewpointReportSubmitParam = {
  spaceId: string;
  spaceProductId: string;
  reportTargetType: string;
  targetId: string;
  reportType: string;
  detailNote?: string;
};

export type ViewpointReportListResult = {
  total: number;
  list: ViewpointReportRow[];
};

export type ViewpointReportRow = {
  id: string;
  reportTargetType: string;
  reportTargetTypeLabel: string;
  reportTargetContent: string;
  reportType: string;
  reportTypeLabel: string;
  detailNote: string;
  status: "pending" | "completed";
  statusLabel: string;
  handleResult: string;
  createdAt: string | Date;
  handledAt: string | Date;
};
